/**
 * Created by zuozhuo on 2018/1/29.
 */
import { observer } from "mobx-react";
import React from "react";
import PropTypes from "prop-types";
import { NavBar, Icon } from "foui";
import classnames from "classnames";
import { Helmet } from "react-helmet";
import utils from "../../utils/utils";
import { APP_NAV_TITLE } from "../../consts/consts";
import storeGlobal from "../../store/storeGlobal";
import "./index.scss";

const GoBackIcon = <Icon onClick={() => utils.goBack()} type="left" />;

function getTitleFromChildren(children) {
  const isTitleStr = typeof children === "string";
  return isTitleStr ? children : APP_NAV_TITLE;
}

@observer
class AppNavBar extends React.Component {
  render() {
    const {
      mode = "light",
      className,
      icon = GoBackIcon,
      alwaysShow,
      replaceTitle,
      miniProgramTitle,
      miniProgramShow,
      ...others
    } = this.props;
    const isMini = storeGlobal.isMiniProgram;

    const navTitle = getTitleFromChildren(this.props.children);

    const titleSetView = replaceTitle && (
      <Helmet key={"titleSetView"}>
        <title>{navTitle}</title>
      </Helmet>
    );

    // app内和微信内不展示导航栏
    if (!alwaysShow && (utils.isFoApp() || utils.isWeiXin() || isMini)) {
      // 当不是小程序环境，或是小程序环境，但miniProgramShow为假时不展示导航栏
      if (!isMini || !miniProgramShow) {
        return titleSetView;
      }
    }

    const newProps = {
      mode,
      className: classnames(className, "AppNavBar"),
      icon,
      ...others
    };
    if (!alwaysShow && isMini) {
      newProps.children = miniProgramTitle;
    }
    return [titleSetView, <NavBar key={"navbar"} {...newProps} />];
  }
}
/*
API#
适用平台：WEB
属性	说明	类型	默认值
mode	模式	string	'dark' enum{'dark', 'light'}
icon	出现在最左边的图标占位符	ReactNode	-
leftContent	导航左边内容	any	无
rightContent	导航右边内容	any	无
onLeftClick	导航左边点击回调	(e: Object): void	无
 */
AppNavBar.propTypes = {
  alwaysShow: PropTypes.bool.isRequired,
  miniProgramTitle: PropTypes.string,
  miniProgramShow: PropTypes.bool,
  replaceTitle: PropTypes.bool
};
AppNavBar.defaultProps = {
  alwaysShow: false,
  // 小程序环境，值为真时会显示导航条
  miniProgramTitle: "",
  miniProgramShow: false,
  replaceTitle: true
};
export default AppNavBar;



// WEBPACK FOOTER //
// ./src/components/AppNavBar/index.js